export const isWindow = typeof window === "object";

export const getSourceUrl = () =>
  isWindow ? window?.location?.href : undefined;

export const gerReferrer = () =>
  isWindow ? window?.document?.referrer : undefined;
